import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=7b05eff2&scoped=true&"
import script from "./CategoryList.vue?vue&type=script&lang=ts&"
export * from "./CategoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b05eff2",
  null
  
)

export default component.exports